import { Outlet } from 'react-router-dom';

import { ContentContainer, Wrapper } from '@american-autonomy/rantizo-ui';

import SiteFooter from 'components/SiteFooter';
import SiteHeader from 'components/SiteHeader';
import Toast from 'components/Toast';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props, TypeMap } from './types';

import styles from './styles.module.scss';

const typeMap: TypeMap = {
    wide: styles.wide
};

const Layout: FunctionComponent<Props> = ({ testId = TEST_ID, type = '' }) => {
    const className = typeMap[type] || '';

    return (
        <>
            <div className={styles.layout} data-testid={testId}>
                <SiteHeader />

                <Wrapper className={styles.wrapper}>
                    <ContentContainer className={`${className} ${styles.contentContainer}`}>
                        <Outlet />
                    </ContentContainer>

                    <SiteFooter className={styles.siteFooter} />
                </Wrapper>
            </div>

            <Toast />
        </>
    );
};

export default Layout;
